class QuantitySelector extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.render();
    this.setupEventListeners();
  }

  static get observedAttributes() {
    return ['value', 'min', 'max', 'name', 'id'];
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (oldValue !== newValue) {
      this.render();
      this.setupEventListeners();
    }
  }

  get value() {
    return parseInt(this.getAttribute('value') || '1');
  }

  set value(val) {
    const newValue = Math.max(this.min, Math.min(this.max, parseInt(val) || 1));
    this.setAttribute('value', newValue.toString());
    
    // Update the input value and button states
    const input = this.querySelector('input');
    if (input) {
      input.value = newValue;
    }
    this.updateButtonStates();
    
    this.dispatchEvent(new CustomEvent('quantity-change', {
      detail: { value: newValue },
      bubbles: true
    }));
  }

  get min() {
    return parseInt(this.getAttribute('min') || '1');
  }

  get max() {
    return parseInt(this.getAttribute('max') || '10');
  }

  get name() {
    return this.getAttribute('name') || 'quantity';
  }

  get inputId() {
    return this.getAttribute('id') || 'quantity';
  }

  render() {
    this.innerHTML = `
      <div class="flex items-center bg-gray-50 rounded-lg border border-gray-200 hover:border-gray-300 focus-within:border-primary focus-within:ring-1 focus-within:ring-primary transition-all">
        <button type="button" class="qty-btn-minus p-3 text-gray-400 hover:text-gray-600 transition-colors" aria-label="Decrease quantity">
          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M20 12H4"></path>
          </svg>
        </button>
        
        <input
          type="number"
          class="w-16 text-center bg-transparent border-0 focus:ring-0 font-medium text-gray-900"
          value="${this.value}"
          min="${this.min}"
          max="${this.max}"
          name="${this.name}"
          id="${this.inputId}"
          readonly
        >
        
        <button type="button" class="qty-btn-plus p-3 text-gray-400 hover:text-gray-600 transition-colors" aria-label="Increase quantity">
          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6v6m0 0v6m0-6h6m-6 0H6"></path>
          </svg>
        </button>
      </div>
    `;
  }

  setupEventListeners() {
    const minusBtn = this.querySelector('.qty-btn-minus');
    const plusBtn = this.querySelector('.qty-btn-plus');
    const input = this.querySelector('input');

    minusBtn.addEventListener('click', () => {
      if (this.value > this.min) {
        this.value = this.value - 1;
      }
    });

    plusBtn.addEventListener('click', () => {
      if (this.value < this.max) {
        this.value = this.value + 1;
      }
    });

    input.addEventListener('change', (e) => {
      this.value = parseInt(e.target.value) || 1;
    });

    // Initial button state update
    this.updateButtonStates();
  }

  updateButtonStates() {
    const minusBtn = this.querySelector('.qty-btn-minus');
    const plusBtn = this.querySelector('.qty-btn-plus');
    
    if (minusBtn && plusBtn) {
      minusBtn.disabled = this.value <= this.min;
      plusBtn.disabled = this.value >= this.max;
    }
  }
}

customElements.define('quantity-selector', QuantitySelector);